/* eslint-disable global-require */
const { en: common } = require("../../common");

module.exports = {
	...common,
	"vector-nti": require("./vector-nti.json"),
};
